/**
 * Utility functions for handling domain detection in different environments
 */

/**
 * Get the correct domain for QR code generation
 * When running in mobile app (APK), window.location.origin will be localhost
 * We need to use the hosted domain instead
 */
export const getPublicDomain = (): string => {
  // Check if we're running in a mobile app environment
  const isMobileApp = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('192.168.') ||
                     window.location.hostname.includes('10.0.') ||
                     window.location.hostname.includes('172.16.') ||
                     window.location.hostname.includes('172.17.') ||
                     window.location.hostname.includes('172.18.') ||
                     window.location.hostname.includes('172.19.') ||
                     window.location.hostname.includes('172.20.') ||
                     window.location.hostname.includes('172.21.') ||
                     window.location.hostname.includes('172.22.') ||
                     window.location.hostname.includes('172.23.') ||
                     window.location.hostname.includes('172.24.') ||
                     window.location.hostname.includes('172.25.') ||
                     window.location.hostname.includes('172.26.') ||
                     window.location.hostname.includes('172.27.') ||
                     window.location.hostname.includes('172.28.') ||
                     window.location.hostname.includes('172.29.') ||
                     window.location.hostname.includes('172.30.') ||
                     window.location.hostname.includes('172.31.');

  // If we're in a mobile app or local development, use the hosted domain
  if (isMobileApp) {
    return 'https://cafelawn.web.app';
  }

  // Otherwise use the current origin (for web browser)
  return window.location.origin;
};

/**
 * Generate a public URL for QR codes
 * @param path - The path to append to the domain (without leading slash)
 * @returns The complete public URL
 */
export const getPublicUrl = (path: string): string => {
  const domain = getPublicDomain();
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${domain}/${cleanPath}`;
}; 